import {Input} from "./Input.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";

export class SubDomainInput extends Input {

    template() {
        const {addClassName = "", inputId = 'subDomainInput'} = this.$props;
        return `
                    <div id="subDomainInputTempLayer" >
                          <input
                           id="${inputId}"
                           class="${addClassName}"
                           type="text" 
                            data-valid="teamUrl"
                            data-required-yn="Y" 
                            maxlength="50" 
                            data-over-msg="${i18next.t(login.inputAlert, {val: 50})}" 
                            data-empty-msg="${i18next.t(login.common.enter, {val: $t(login.companyURL)})}" 
                            data-un-valid-msg="${i18next.t(login.companyURLPlaceHolder)}"
                            placeholder="${i18next.t(login.companyURL2)}">
                          <span>.${location.host}</span>
                        </div>
                        <p class="error-txt-wrap">
                          <span class="js-error-txt"></span>
                        </p>
        `
    }
    getInputSelector() {
        const {inputId = "subDomainInput"} = this.$props;
        return `#${inputId}`
    }
    inputValidate() {
        const $subDomainInput = $(`${this.getInputSelector()}`);

        // 서브도메인일 경우에는 상위 DIV를 통해 에러 처리
        const errorJson = InputValidator.getInputErrorJson($subDomainInput);
        const isError = Object.values(errorJson).length > 0;
        if (isError) {
            InputErrorHandler.activeErrorModeAboutInput(this.getInputErrorElement(), errorJson.errorMessage)
            return false;
        }
        InputErrorHandler.unActiveErrorModeAboutInput(this.getInputErrorElement());
        return true;
    }

    getInputErrorElement() {
        return $("#subDomainInputTempLayer")
    }
}